import { shared } from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';

const isoDatetimeString = z.preprocess(
  (v) => (v instanceof Date ? v.toISOString() : v),
  z.iso.datetime({ offset: true }),
);

export const OutputPassportData = z.object({
  id: shared.SlideScanId,
  physicalId: z.string().optional(),
  triggeredAt: isoDatetimeString.optional(),
  uploadedAt: isoDatetimeString.optional(),
  verifiedAt: isoDatetimeString.optional(),
  labelUri: z.string().optional(),
  macroUri: z.string().optional(),
  wsiThumbnailUri: z.string().optional(),
  scannerType: z.string().optional(),
  scannerSerial: z.string().optional(),
  rackNumber: z.number().nonnegative().optional(),
  rackPosition: z.number().nonnegative().optional(),
  staining: z.string().optional(),
  customField1: z.string().optional(),
  magnification: z.number().nonnegative().optional(),
  processingState: shared.SlideScanStatus,
  generalQcStatus: shared.SlideScanGeneralQcStatus,
  aiProcessingStatus: shared.SlideScanItem.shape.aiProcessingStatus,
  aggregatedStatus: shared.AggregatedStatus.optional(),
  isRescan: z.boolean(),
  scanNumber: z.number().nonnegative().optional(),
  caseName: z.string(),
  slideName: z.string(),
  slideScanDisplayName: z.string().optional(),
  bodyPart: z.string().optional(),
  issues: z.array(shared.SlideScanDetectedIssue).optional(),
});

export const OutputPassportResponse = z
  .object({
    data: OutputPassportData,
    credentials: shared.BucketCredentialsWithKeys,
  });

export type OutputPassportResponseType = z.infer<typeof OutputPassportResponse>;
export type OutputPassportDataType = z.infer<typeof OutputPassportData>;

export const OutputPassportQueryParams = z.object({
  externalSlideScanId: z.string().min(1).describe(
    'The externalSlideScanId from the integrator to fetch the output passport for.',
  ),
});
export type OutputPassportQueryParamsType = z.infer<typeof OutputPassportQueryParams>;
